import { cn } from "@/lib/utils";
import type { InfoCardProps } from "../types";

export function InfoCard({
  title,
  description,
  icon,
  className,
}: InfoCardProps) {
  const Icon = icon;
  return (
    <div
      className={cn(
        "flex-1 rounded-lg bg-green-800 p-5 lg:w-fit lg:max-w-[296px] lg:flex-none",
        className
      )}
    >
      <Icon />
      <h3 className="text-black-400 mt-2 text-lg font-medium tracking-copy md:text-xl lg:text-2xl">
        {title}
      </h3>
      <p className="text-black-100 mt-1 text-sm lg:text-base lg:leading-[22px]">
        {description}
      </p>
    </div>
  );
}
